import React from "react";
import { Box, Typography, Alert } from "@mui/material";
import { VerificationResult } from "../../../types/contract";

interface VerificationSectionProps {
  verification: VerificationResult;
}

export const VerificationSection: React.FC<VerificationSectionProps> = ({
  verification,
}) => (
  <Box>
    <Typography variant="h6" gutterBottom>
      レントロールとの照合結果
    </Typography>
    <Box sx={{ p: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      {/* レントロールにない契約書がない場合に成功メッセージを表示 */}
      {verification.unmatched_contracts.length === 0 && (
        <Alert
          severity="success"
          sx={{ backgroundColor: "#ccffea", color: "black" }} // New green background, black text
        >
          全ての書類がレントロールデータと一致しました。
        </Alert>
      )}

      {/* 不足書類がある場合に警告を表示 */}
      {verification.missing_documents.length > 0 && (
        <Box>
          <Typography variant="subtitle1" color="error">
            不足書類あり
          </Typography>
          <Alert severity="warning">
            {verification.missing_documents.map((item, index) => (
              <div key={index}>
                <strong>
                  {item.property_name}, {item.room_name}, {item.lessee_name}:
                </strong>
                <br />└ 不足: {item.missing_documents.join(", ")}
              </div>
            ))}
          </Alert>
        </Box>
      )}

      {/* レントロールにない契約書がある場合にエラーを表示 */}
      {verification.unmatched_contracts.length > 0 && (
        <Box>
          <Typography variant="subtitle1" color="error">
            レントロールにない契約書
          </Typography>
          <Alert severity="error">
            {verification.unmatched_contracts.map((contract, index) => (
              <div key={index}>
                <strong>
                  {(contract.filename || "").split(/[/／]/).pop()}
                </strong>{" "}
                ({contract.property_name}, {contract.room_name},{" "}
                {contract.lessee_name}, {contract.document_type})
                はレントロールに一致する情報がありません。
              </div>
            ))}
          </Alert>
        </Box>
      )}
    </Box>
  </Box>
);
